export default __webpack_public_path__ + "static/media/CRMNewActive.1706ca98.svg";